<template>
  <div id="export_container" class="dropdown">
    <v-dialog
      id="export_modal"
      ref="export_modal"
      scrollable
      v-model="export_modal"
      maxWidth="90%"
      width="700"
      :persistent="true"
      :style="`z-index: ${this.core.confirmationIndex - 1};position: fixed;`"
    >
      <v-card>
        <v-toolbar dark color="primary">
          {{ $t("common.export") }}<v-spacer></v-spacer>
          <v-btn
            icon
            dark
            large
            @click.stop="core.tour2.runExportSteps()"
            :title="$t('common.helpTitleTips')"
            ><v-icon>mdi-help-circle</v-icon>
          </v-btn>
          <v-btn icon @click="export_modal = false"
            ><v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid>
            <v-row class="my-1">
              <v-col cols="3" class="import_modal_label"
                ><label for="format" style="color: rgba(0, 0, 0, 0.87)"
                  >{{ $t("common.importDialog.format") }}:</label
                ></v-col
              >
              <v-col cols="9">
                <div id="export_formats" class="export_formats">
                  <v-btn
                    :class="
                      'export_modal_button' +
                      (current_format == format ? ' success' : '')
                    "
                    :key="format"
                    v-for="format in formats"
                    @click="updataCurrentFormat(format)"
                    >{{ format }}</v-btn
                  >
                </div>
              </v-col>
              <template v-if="current_format == GLOBAL.EXPORT.FORMATS.GML">
                <v-col cols="9" id="csdi-checkbox">
                  <v-checkbox v-model="csid_format" dense 
                    :label="$t('common.importDialog.exportGMLForCSDI')" />
                </v-col>
              </template>

              <!-- 20210108 - tedngok - hidden crs
          <template>
            <b-col cols="3" class="import_modal_label"
              ><label for="coordinateReferenceSystem"
                >{{ $t("common.coordinateReferenceSystem") }}:</label
              ></b-col
            >
            <b-col cols="9">
              <b-button
                class="import_modal_button"
                :key="crs_option"
                v-for="crs_option in crs_options"
                @click="current_crs_option = crs_option"
                :variant="current_crs_option == crs_option ? 'success' : ''"
                >{{ crs_option }}</b-button
              >
            </b-col>
          </template>
          -->

              <!-- Reminder Empty Marker -->
              <template
                v-if="
                  (noAddressTableItems().length > 0 &&
                    current_format != GLOBAL.EXPORT.FORMATS.CSV) ||
                  hasAutoMatchTableItems().length > 0
                "
              >
                <v-container fluid>
                  <v-card>
                    <v-card-title
                      ><v-icon color="error">warning</v-icon
                      ><span>{{
                        $t("common.importDialog.reminder")
                      }}</span></v-card-title
                    >
                    <v-card-text style="padding: 5px; color: red">
                      <div
                        v-if="hasAutoMatchTableItems().length > 0"
                        v-html="
                          $t(
                            'common.importDialog.exportAutoMatchDownloadMessage'
                          )
                        "
                      ></div>

                      <div
                        v-if="
                          noAddressTableItems().length > 0 &&
                          current_format != GLOBAL.EXPORT.FORMATS.CSV
                        "
                        v-html="
                          $t(
                            'common.importDialog.exportNotIncludeNonMarkerMessage'
                          )
                        "
                      ></div>
                    </v-card-text>
                  </v-card>
                </v-container>
              </template>

              <!--Empty Field Name for GML
              <template v-if="hasEmptyFieldsNameForGML().length > 0">
                <v-container fluid>
                  <v-card>
                    <v-card-title
                      ><v-icon color="error">warning</v-icon
                      ><span>{{
                        $t("common.importDialog.foundProblem")
                      }}</span></v-card-title
                    >
                    <v-card-text style="padding: 5px; color: red">
                      <div
                        v-html="
                          $t('common.importDialog.exportContainEmptyFieldsNameForGML')
                        "
                      ></div>
                    </v-card-text>
                  </v-card>
                </v-container>
              </template>
              -->

              <template v-if="hasStartFieldsNameWithLetterForGML().length > 0">
                <v-container fluid>
                  <v-card>
                    <v-card-title
                      ><v-icon color="error">warning</v-icon
                      ><span>{{
                        $t("common.importDialog.foundProblem")
                      }}</span></v-card-title
                    >
                    <v-card-text style="padding: 5px; color: red">
                      <div
                        v-html="
                          $t(
                            'common.importDialog.exportFieldsNameStartWithLetterForGML'
                          )
                        "
                      ></div>
                    </v-card-text>
                  </v-card>
                </v-container>
              </template>

              <template v-if="overStringSizeForGML()">
                <v-container fluid>
                  <v-card>
                    <v-card-title
                      ><v-icon color="error">warning</v-icon
                      ><span>{{
                        $t("common.importDialog.foundProblem")
                      }}</span></v-card-title
                    >
                    <v-card-text style="padding: 5px; color: red">
                      <div
                        v-html="
                          $t('common.importDialog.exportOverStringSizeForGML')
                        "
                      ></div>
                    </v-card-text>
                  </v-card>
                </v-container>
              </template>

              <!-- Reminder GML Special Field Names -->
              <template
                v-if="hasIEGMLNotAvailableFieldsTableItems().length > 0"
              >
                <v-container fluid>
                  <v-card>
                    <v-card-title
                      ><v-icon color="error">warning</v-icon
                      ><span>{{
                        $t("common.importDialog.foundProblem")
                      }}</span></v-card-title
                    >
                    <v-card-text style="padding: 5px; color: red">
                      <div
                        v-html="
                          $t(
                            'common.importDialog.exporHasIEGMLNotAvailableFieldsMessage'
                          )
                        "
                      ></div>
                      <div>
                        {{ hasIEGMLNotAvailableFieldsTableItems().join(", ") }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-container>
              </template>

              <ExportDialogError 
                :verifyFunction="hasDuplicatedColumnNameForCSDI"
                i18nErrorString="common.importDialog.exportHasDuplicatedColumnNameForCSDI"
                :export_modal="export_modal"
              />
              <ExportDialogError 
                :verifyFunction="hasInvalidCharacterForCSDI"
                i18nErrorString="common.importDialog.exportHasInvalidNameForCSDI"
                :export_modal="export_modal"
              />
              <ExportDialogError 
                :verifyFunction="hasLongFieldNameForCSDI"
                i18nErrorString="common.importDialog.exportHasLongNameForCSDI"
                :export_modal="export_modal"
              />
              <ExportDialogError 
                :verifyFunction="hasInvalidLayerNameForCSDI"
                i18nErrorString="common.importDialog.exportHasInvalidLayerNameForCSDI"
                :export_modal="export_modal"
              />
              <template
                v-if="hasLongLayerNameForCSDI().length > 0"
              >
                <v-container fluid>
                  <v-card>
                    <v-card-title
                      ><v-icon color="error">warning</v-icon
                      ><span>{{
                        $t("common.importDialog.foundProblem")
                      }}</span></v-card-title
                    >
                    <v-card-text style="padding: 5px; color: red">
                      <div
                        v-html="$t('common.importDialog.exportHasLongLayerNameForCSDI')"
                      ></div>
                    </v-card-text>
                  </v-card>
                </v-container>
              </template>
            </v-row>
            <!-- 20210105  Mask “***Support WGS84 & HK80 CRS Only***” -- Terry Tse
        <b-row>
          <v-chip class="ma-2" small label color="#FFF">{{
            $t("common.supportCRSMessage")
          }}</v-chip>
        </b-row>
        -->
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn large text @click="export_modal = false">{{
            $t("common.cancel")
          }}</v-btn>
          <v-btn
            large
            color="primary"
            @click="trigger_export"
            :disabled="disableDownloadFile()"
            >{{ $t("common.ok") }}</v-btn
          ></v-card-actions
        >
      </v-card>
    </v-dialog>
  </div>
</template>
<script src="./lib/ol.js"></script>
<script>
import * as GLOBAL from "./Global.js";
import localforage from "localforage";
import Papa from "papaparse";
// import * as CustomGA from './CustomGoogleAnalytics.js'
import { isIE } from "mobile-device-detect";

import GeoJSON from "ol/format/GeoJSON";
import KML from "ol/format/KML";
import GML32 from "ol/format/GML32";
import GML3 from "ol/format/GML3";
import GML2 from "ol/format/GML2";
import GML from "ol/format/GML";

import tokml from "geojson-to-kml";
import { DOMParser, XMLSerializer } from "xmldom";
import { zip } from "node-zip";
import xmlFormat from "xml-formatter";
import ExportDialogError from "./ExportDialogError.vue";
const output_formats = isIE
  ? GLOBAL.EXPORT.FORMATS_ARRAY
  : // : ["GeoJSON", "KML", "Shapefile"];
    GLOBAL.EXPORT.FORMATS_ARRAY;
const crs_options = GLOBAL.EXPORT.CRS_OPTIONS_ARRAY;

export default {
  watch: {},

  data: function () {
    return {
      GLOBAL: GLOBAL,

      formats: output_formats,
      crs_options: crs_options,
      current_format: GLOBAL.EXPORT.FORMATS.CSV,
      current_crs_option: GLOBAL.EXPORT.CRS_OPTIONS.WGS1984,
      // options: options,

      export_modal: false,
      csid_format: true,
    };
  },
  props: ["core", "tour"],
  components: {
    ExportDialogError
  },
  methods: {
    // updateGmlFormat(xml, additionalFieldName) {
    updateGmlFormat(xml, updateNewFieldNamesMapping) {
      const doc = new DOMParser().parseFromString(xml, "text/xml");

      let count = doc.getElementsByTagName(this.core.layerName).length;
      Array.prototype.forEach.call(
        doc.getElementsByTagName("geometry"),
        (element) => {
          element.tagName = "gml:pointProperty";
        }
      );

      Array.prototype.forEach.call(
        doc.getElementsByTagName(this.core.layerName),
        (element, index) => {
          let uuid = index + 1;
          element.tagName = "gt:"+this.core.layerName;
          element.setAttribute("gml:id", "feature" + uuid);
          element.removeAttribute("xmlns");
        }
      );

      Array.prototype.forEach.call(
        doc.getElementsByTagName("featureMembers"),
        (element) => {
          element.tagName = "gml:featureMembers";
          element.removeAttribute("xmlns");
          element.removeAttribute("xsi:schemaLocation");
          element.removeAttribute("xmlns:xsi");
        }
      );

      /*
for( let i =0;  i < count; i++  ) {
let geoTag = doc.getElementsByTagName('geotagging')[i].cloneNode(true)
geoTag.tagName = 'gt:geotagging'
geoTag.setAttribute('gml:id', this._uuid() )
doc.getElementsByTagName('gml:FeatureCollection')[0].appendChild(doc.createElement("gml:featureMember"))
doc.getElementsByTagName('gml:featureMember')[i].appendChild(geoTag)

}


doc.removeChild(doc.getElementsByTagName('featureMembers')[0])
*/
      Array.prototype.forEach.call(
        doc.getElementsByTagName("Point"),
        (element) => {
          element.setAttribute("srsDimension", "2");
          element.tagName = "gml:Point";
        }
      );
      Array.prototype.forEach.call(
        doc.getElementsByTagName("pos"),
        (element) => {
          element.tagName = "gml:pos";
          element.removeAttribute("srsDimension");
        }
      );
      // additionalFieldName.forEach((fieldName) => {
      //   Array.prototype.forEach.call(
      //     doc.getElementsByTagName(fieldName),
      //     (element) => {
      //       element.tagName = "gt:" + element.tagName;
      //     }
      //   );
      // });

      for (const m in updateNewFieldNamesMapping) {
        Array.prototype.forEach.call(
          doc.getElementsByTagName(updateNewFieldNamesMapping[m]),
          (element) => {
            element.tagName = "gt:" + element.tagName;
          }
        );
      }

      let docStr = new XMLSerializer().serializeToString(doc);

      // console.log(docStr)

      docStr = docStr
        .replaceAll(/<gml:featureMembers.*?>/g, "")
        .replaceAll(/<\/gml:featureMembers.*?>/g, "")

        // .replaceAll('<gml:featureMembers xmlns="http://www.opengis.net/gml">', '')
        // .replaceAll('<gml:featureMembers>', '')
        //                .replaceAll('</gml:featureMembers>', '')
        .replaceAll("</gt:"+this.core.layerName+">", "</gt:"+this.core.layerName+"></gml:featureMember>")
        .replaceAll("<gt:"+this.core.layerName, "<gml:featureMember><gt:"+this.core.layerName);

      return docStr;
    },
    // getXsdStr(additionalFieldName) {
    getXsdStr(updateNewFieldNamesMapping) {
      let str = "";

      for (const m in updateNewFieldNamesMapping) {
        str +=
          '<element name="' +
          updateNewFieldNamesMapping[m] +
          '" nillable="true" minOccurs="0" maxOccurs="1">' +
          "<simpleType>" +
          '<restriction base="string">' +
          '<maxLength value="5000"/>' +
          "</restriction>" +
          "</simpleType>" +
          "</element>";
      }

      // additionalFieldName.forEach((fieldName) => {
      //   str +=
      //     '<element name="' +
      //     fieldName +
      //     '" nillable="true" minOccurs="0" maxOccurs="1">' +
      //     "<simpleType>" +
      //     '<restriction base="string">' +
      //     '<maxLength value="5000"/>' +
      //     "</restriction>" +
      //     "</simpleType>" +
      //     "</element>";
      // });

      let resultStr =
        '<?xml version="1.0" encoding="UTF-8"?>' +
        '<schema xmlns:gt="https://geodata.gov.hk/gt/" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:gml="http://www.opengis.net/gml" xmlns="http://www.w3.org/2001/XMLSchema" targetNamespace="https://geodata.gov.hk/gt/" elementFormDefault="qualified">' +
        '<import namespace="http://www.opengis.net/gml" schemaLocation="http://schemas.opengis.net/gml/3.1.1/base/gml.xsd"/>' +
        '<element name="'+this.core.layerName+'" type="gt:geotaggingType" substitutionGroup="gml:_Feature"/>' +
        '<complexType name="geotaggingType">' +
        "<complexContent>" +
        '<extension base="gml:AbstractFeatureType">' +
        "<sequence>" +
        '<element ref="gml:pointProperty" minOccurs="1" maxOccurs="1"/>' +
        str +
        "</sequence>" +
        "</extension>" +
        "</complexContent>" +
        "</complexType>" +
        "</schema>";

      return resultStr;
    },

    _uuid() {
      var d = Date.now();
      if (
        typeof performance !== "undefined" &&
        typeof performance.now === "function"
      ) {
        d += performance.now(); //use high-precision timer if available
      }
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
    },

    getGmlEnvelope(json_data) {
      let xList = [];
      let yList = [];
      Array.prototype.forEach.call(json_data, (element) => {
        yList.push(element.geometryChangeKey_.target.flatCoordinates[0]);
        xList.push(element.geometryChangeKey_.target.flatCoordinates[1]);
      });

      //<gml:lowerCorner>22.207508 113.943831</gml:lowerCorner>
      //<gml:upperCorner>22.500277 114.268235</gml:upperCorner>

      let result = {
        lowerCornerX: Math.min(...xList),
        lowerCornerY: Math.min(...yList),
        upperCornerX: Math.max(...xList),
        upperCornerY: Math.max(...yList),
      };
      return result;
    },
    disableDownloadFile() {
      if (this.hasIEGMLNotAvailableFieldsTableItems().length > 0) {
        return true;
      }

      if (this.current_format != this.GLOBAL.IMPORT.FORMATS.CSV) {
        if (this.core.tableItems.length <= this.noAddressTableItems().length) {
          return true;
        }
      }

      if (
        this.hasEmptyFieldsNameForGML().length > 0 ||
        this.hasStartFieldsNameWithLetterForGML().length > 0 ||
        this.overStringSizeForGML()
      ) {
        return true;
      }

      // For CSDI GML export validation
      if (
        this.hasDuplicatedColumnNameForCSDI().length > 0 ||
        this.hasInvalidCharacterForCSDI().length > 0 ||
        this.hasLongFieldNameForCSDI().length > 0 ||
        this.hasLongLayerNameForCSDI().length > 0 || 
        this.hasInvalidLayerNameForCSDI().length > 0
      ) {
        return true;
      }

      return false;
    },

    downloadFileDateTimeString() {
      let now = new Date();
      return `${now.getFullYear()}${(now.getMonth() + 1)
        .toString()
        .padStart(2, 0)}${now.getDate().toString().padStart(2, 0)}_${now
        .getHours()
        .toString()
        .padStart(2, 0)}${now.getMinutes().toString().padStart(2, 0)}`;
    },

    hasEmptyFieldsNameForGML() {
      let dynamicFields = this.core.dynamicFields,
        resultList = [];

      if (this.current_format != GLOBAL.EXPORT.FORMATS.GML) {
        return [];
      }

      for (let i = 0; i < dynamicFields.length; i++) {
        let dynamicField = dynamicFields[i];
        if (dynamicField.label.trim() == "") {
          resultList.push(dynamicField.label);
        }
      }

      return resultList;
    },
    overStringSizeForGML() {
      let over = false;
      if (this.current_format != GLOBAL.EXPORT.FORMATS.GML) {
        return false;
      }
      let collectionLayers = this.core.drawnItems;

      let olFeatures = new GeoJSON().readFeatures(collectionLayers.toGeoJSON());

      for (let i = 0; i < olFeatures.length; i++) {
        let properties = olFeatures[i].getProperties();
        Object.entries(properties).forEach((entry) => {
          const [key, value] = entry;

          if (typeof value === "string" && value !== null) {
            // console.log(`${key}: ${value}`);
            if (value.length > 5000) {
              over = true;
              return over;
            }
          }
        });
      }

      return over;
    },
    hasStartFieldsNameWithLetterForGML() {
      //console.log( JSON.stringify(this.core.drawnItems));

      let dynamicFields = this.core.dynamicFields,
        resultList = [];

      if (this.current_format != GLOBAL.EXPORT.FORMATS.GML) {
        return [];
      }

      for (let i = 0; i < dynamicFields.length; i++) {
        let dynamicField = dynamicFields[i];

        let startChar = dynamicField.label.charAt(0);
        if (startChar !== "_" && !/^[a-z]$/i.test(startChar)) {
          resultList.push(dynamicField.label);
        }
      }

      return resultList;
    },

    hasDuplicatedColumnNameForCSDI() {
      let dynamicFields = this.core.dynamicFields;

      if (!this.export_modal || this.current_format != GLOBAL.EXPORT.FORMATS.GML || !this.csid_format) {
        if (this.current_format != GLOBAL.EXPORT.FORMATS.GML)
          this.core.exportGmlColumnExistedList = [];
        return [];
      }

      const resultList = this.core.checkDuplicatedFieldname();
      this.core.exportGmlColumnExistedList = resultList;
      return resultList;
    },

    hasInvalidCharacterForCSDI() {
      let dynamicFields = this.core.dynamicFields,
        resultList = [];

      if (!this.export_modal || this.current_format != GLOBAL.EXPORT.FORMATS.GML || !this.csid_format) {
        if (this.current_format != GLOBAL.EXPORT.FORMATS.GML)
          this.core.exportGmlInvalidNameList = [];
        return [];
      }

      dynamicFields.forEach((element, i) => {
        if (element.label.match(GLOBAL.COLUMN_NAME_FILTER))
          resultList.push({no: i+1, field: element.label});
      });
      this.core.exportGmlInvalidNameList = resultList;
      return resultList;
    },

    hasInvalidLayerNameForCSDI() {
      let layerName = this.core.layerName,
        resultList = [];

      if (!this.export_modal || this.current_format != GLOBAL.EXPORT.FORMATS.GML || !this.csid_format) {
        if (this.current_format != GLOBAL.EXPORT.FORMATS.GML)
          this.core.exportGmlInvalidNameList = [];
        return [];
      }

      if (layerName.match(GLOBAL.COLUMN_NAME_FILTER))
        resultList.push({layerName: layerName});
      this.core.exportGmlInvalidNameList = resultList;
      return resultList;
    },

    hasLongFieldNameForCSDI() {
      let dynamicFields = this.core.dynamicFields,
        resultList = [];

      if (!this.export_modal || this.current_format != GLOBAL.EXPORT.FORMATS.GML || !this.csid_format) {
        if (this.current_format != GLOBAL.EXPORT.FORMATS.GML)
          this.core.exportGmlLongNameList = [];
        return [];
      }

      dynamicFields.forEach((element, i) => {
        if (element.label.length > 64)
          resultList.push({no: i+1, field: element.label});
      });
      this.core.exportGmlLongNameList = resultList;
      return resultList;
    },

    hasLongLayerNameForCSDI() {
      let layerName = this.core.layerName,
        resultList = [];

      if (!this.export_modal || this.current_format == GLOBAL.EXPORT.FORMATS.CSV || !this.csid_format) {
        if (this.current_format == GLOBAL.EXPORT.FORMATS.CSV)
          this.core.exportLongLayerNamesCSDI
        return [];
      }

      if (layerName.length > 160) {
        resultList.push({layerName: layerName});
      }
      this.core.exportLongLayerNamesCSDI = resultList;
      return resultList;
    },

    hasIEGMLNotAvailableFieldsTableItems() {
      //skip not ie or gml format
      if (!isIE || this.current_format != GLOBAL.EXPORT.FORMATS.GML) {
        return [];
      }

      //chinese checking
      let chiReg = new RegExp("[\u4E00-\uFA29]"),
        dynamicFields = this.core.dynamicFields,
        resultList = [];

      for (let i = 0; i < dynamicFields.length; i++) {
        let dynamicField = dynamicFields[i];
        if (chiReg.test(dynamicField.label)) {
          resultList.push(dynamicField.label);
        }
      }

      return resultList;
    },

    noAddressTableItems() {
      return this.core.tableItems.filter((tableItem) =>
        !tableItem.leaflet_id ? true : false
      );
    },

    hasAutoMatchTableItems() {
      return this.core.tableItems.filter((tableItem) => {
        return tableItem.automatched ? true : false;
      });
    },

    updataCurrentFormat(format) {
      this.current_format = format;
    },

    async show_export_modal() {
      // this.$refs["export_modal"].show();
      this.export_modal = true;

      this.$GA.export_open();

      if ((await localforage.getItem("showExportTour")) !== false) {
        this.core.tour2.runExportSteps();
        localforage.setItem("showExportTour", false);
      }

      //set the overlay z-index to 1002 to cover left bar menu
      $(".v-overlay").css("z-index", "1002");
    },

    json2CSV(json) {
      try {
        let stringArray = [];
        for (let i = 0; i < this.core.dynamicFields.length; i++) {
          stringArray.push(this.core.dynamicFields[i]["label"]);
        }

        stringArray.push(GLOBAL.HIDDEN_FIELD_LABELS.LONGITUDE);
        stringArray.push(GLOBAL.HIDDEN_FIELD_LABELS.LATITUDE);
        stringArray.push(GLOBAL.HIDDEN_FIELD_LABELS.EASTING);
        stringArray.push(GLOBAL.HIDDEN_FIELD_LABELS.NORTHING);

        return Papa.unparse(json, {
          delimiter: ",",
          quoteChar: '"',
          escapeChar: '"',
          columns: stringArray,
          header: true,
        });
      } catch (err) {
        console.log(err);
        return null;
      }
    },
    trigger_export: function () {
      try {
        this.$GA.export_submit(this.current_format, this.current_crs_option);

        let convertedData = "",
          link = document.createElement("a"),
          olFeatures = null,
          gmlString = null,
          collectionLayers = [];

        //for openlayer
        let options = {};
        if (this.current_crs_option != GLOBAL.EXPORT.CRS_OPTIONS.WGS1984) {
          options = {
            dataProjection: GLOBAL.CRS_TO_EPSG[this.current_crs_option],
            featureProjection: GLOBAL.CRS_TO_EPSG.WGS1984,
            srsName: GLOBAL.CRS_TO_EPSG[this.current_crs_option],
          };
        } else {
          options = {
            dataProjection: GLOBAL.CRS_TO_EPSG.WGS1984,
            featureProjection: GLOBAL.CRS_TO_EPSG.WGS1984,
            srsName: GLOBAL.CRS_TO_EPSG.WGS1984,
          };
        }

        //sort for layers properties

        const layers = this.core.drawnItems.getLayers();
        for (let i = 0; i < layers.length; i++) {
          // const sortedProperties = this.core.drawnItems[i].feature.properties

          let layer = layers[i];

          let newProperties = {};

          //skip if empty properties
          if (layer.feature.properties == undefined) {
            continue;
          }

          for (let j = 0; j < this.core.dynamicFields.length; j++) {
            const dynamicField = this.core.dynamicFields[j];

            if (
              layer.feature.properties != undefined &&
              layer.feature.properties.hasOwnProperty(dynamicField.label)
            ) {
              newProperties[dynamicField.label] =
                layer.feature.properties[dynamicField.label];
            }
          }

          newProperties = { ...newProperties, ...layer.feature.properties };

          layer.feature.properties = newProperties;
        }

        switch (this.current_format) {
          case GLOBAL.EXPORT.FORMATS.CSV:
            this.$GA.export_csv();

            collectionLayers = this.core.drawnItems;
            let csv_data = [];

            for (let i = 0; i < this.core.tableItems.length; i++) {
              let tableItem = this.core.tableItems[i],
                properties = {};

              if (tableItem.geojson && tableItem.geojson.properties) {
                properties = tableItem.geojson.properties;
              } else if (tableItem.item) {
                properties = tableItem.item;
              }

              if (tableItem.leaflet_id) {
                let layer = collectionLayers.getLayer(tableItem.leaflet_id);

                //point
                if (typeof layer.getLatLng == "function") {
                  let coordinates = layer.getLatLng();

                  //for non hk80 & wgs84
                  let reCoordinates2 = null;
                  if (
                    this.current_crs_option !=
                      GLOBAL.EXPORT.CRS_OPTIONS.WGS1984 &&
                    this.current_crs_option != GLOBAL.EXPORT.CRS_OPTIONS.HK1980
                  ) {
                    reCoordinates2 = ol.proj.transform(
                      [coordinates.lng, coordinates.lat],
                      GLOBAL.CRS_TO_EPSG.WGS1984,
                      GLOBAL.CRS_TO_EPSG[this.current_crs_option]
                    );
                  }

                  let reCoordinates = ol.proj.transform(
                    [coordinates.lng, coordinates.lat],
                    GLOBAL.CRS_TO_EPSG.WGS1984,
                    GLOBAL.CRS_TO_EPSG.HK1980
                  );

                  csv_data.push({
                    ...properties,
                    [`${GLOBAL.HIDDEN_FIELD_LABELS.LONGITUDE}`]:
                      this.core.displayLng(
                        reCoordinates2 ? reCoordinates2[0] : coordinates.lng
                      ),
                    [`${GLOBAL.HIDDEN_FIELD_LABELS.LATITUDE}`]:
                      this.core.displayLat(
                        reCoordinates2 ? reCoordinates2[1] : coordinates.lat
                      ),
                    [`${GLOBAL.HIDDEN_FIELD_LABELS.EASTING}`]:
                      this.core.displayHK80X(reCoordinates[0]),
                    [`${GLOBAL.HIDDEN_FIELD_LABELS.NORTHING}`]:
                      this.core.displayHK80Y(reCoordinates[1]),
                  });

                  //shape
                } else if (typeof layer.getLatLngs == "function") {
                  let center = layer.getBounds().getCenter();

                  //for non hk80 & wgs84
                  let reCoordinates2 = null;
                  if (
                    this.current_crs_option !=
                      GLOBAL.EXPORT.CRS_OPTIONS.WGS1984 &&
                    this.current_crs_option != GLOBAL.EXPORT.CRS_OPTIONS.HK1980
                  ) {
                    reCoordinates2 = ol.proj.transform(
                      [center.lng, center.lat],
                      GLOBAL.CRS_TO_EPSG.WGS1984,
                      GLOBAL.CRS_TO_EPSG[this.current_crs_option]
                    );
                  }

                  let reCoordinates = ol.proj.transform(
                    [center.lng, center.lat],
                    GLOBAL.CRS_TO_EPSG.WGS1984,
                    GLOBAL.CRS_TO_EPSG.HK1980
                  );

                  csv_data.push({
                    ...properties,
                    [`${GLOBAL.HIDDEN_FIELD_LABELS.LONGITUDE}`]:
                      this.core.displayLng(
                        reCoordinates2 ? reCoordinates2 : center.lng
                      ),
                    [`${GLOBAL.HIDDEN_FIELD_LABELS.LATITUDE}`]:
                      this.core.displayLat(
                        reCoordinates2 ? reCoordinates2 : center.lat
                      ),
                    [`${GLOBAL.HIDDEN_FIELD_LABELS.EASTING}`]:
                      this.core.displayHK80X(reCoordinates[0]),
                    [`${GLOBAL.HIDDEN_FIELD_LABELS.NORTHING}`]:
                      this.core.displayHK80Y(reCoordinates[1]),
                  });
                }
              } else {
                csv_data.push({
                  ...properties,
                });
              }
            }

            csv_data = this.json2CSV(csv_data);

            convertedData =
              "text/csv;charset=utf-8," +
              encodeURIComponent("\uFEFF" + csv_data);

            if (!isIE) {
              link.href = "data:" + convertedData;
              link.download =
                "download_" + this.downloadFileDateTimeString() + ".csv";
            } else {
              window.navigator.msSaveOrOpenBlob(
                new Blob(["\uFEFF" + csv_data], {
                  type: "text/csv; charset=utf-8",
                }),
                "download_" + this.downloadFileDateTimeString() + ".csv"
              );
            }

            break;

          case GLOBAL.EXPORT.FORMATS.GEOJSON:
            this.$GA.export_geojson();

            //20210108 - tedngok - hidden for only wgs84
            // if (this.current_crs_option != GLOBAL.EXPORT.CRS_OPTIONS.WGS1984) {
            //   collectionLayers = L.geoJson(this.drawnItems.toGeoJSON().features);

            //   collectionLayers = this.$parent.import.convertCRS(
            //     collectionLayers,
            //     GLOBAL.EXPORT.CRS_OPTIONS.WGS1984,
            //     this.current_crs_option
            //   );
            // } else {
            //   collectionLayers = this.drawnItems;
            // }
            collectionLayers = this.core.drawnItems;

            //attach crs attribute
            let resultJSON = collectionLayers.toGeoJSON();

            resultJSON.crs = {
              type: "name",
              properties: {
                name: GLOBAL.CRS_TO_EPSG[this.current_crs_option],
              },
            };

            let geojsonResult = JSON.stringify(resultJSON);
            convertedData =
              "text/json;charset=utf-8," + encodeURIComponent(geojsonResult);

            if (!isIE) {
              link.href = "data:" + convertedData;
              link.download =
                "download_" + this.downloadFileDateTimeString() + ".geojson";
            } else {
              window.navigator.msSaveOrOpenBlob(
                new Blob([geojsonResult], { type: "text/json" }),
                "download_" + this.downloadFileDateTimeString() + ".geojson"
              );
            }

            break;

          case GLOBAL.EXPORT.FORMATS.KML:
            this.$GA.export_kml();

            collectionLayers = this.core.drawnItems;

            olFeatures = new GeoJSON().readFeatures(
              collectionLayers.toGeoJSON()
            );

            for (let i = 0; i < olFeatures.length; i++) {
              let keys = olFeatures[i].getKeys();
              let properties = olFeatures[i].getProperties();
              for (let j = 1; j < keys.length; j++) {
                //start to check field
                // let newKeyName = keys[j].replace(/a-zA-Z0-9-_/g, "_");
                let newKeyName = keys[j].replace(
                  /[-&\/\\#,+()$~%.'":*?<>{}`!@# \n\r\t]/g,
                  "_"
                );

                //utf8 symbol
                newKeyName = newKeyName.replace(
                  /[\uFF08-\uFF60\u3008-\u301E]/g,
                  "_"
                );

                for (let i = 0; i < GLOBAL.KML_RESERVED_WORD.length; i++) {
                  let reservedWord = GLOBAL.KML_RESERVED_WORD[i];
                  if (newKeyName == reservedWord) {
                    olFeatures[i].set("_" + newKeyName, properties[keys[j]]);
                  }
                }

                if (/^[0-9].+$/.test(newKeyName)) {
                  newKeyName = "_" + newKeyName;
                }

                if (newKeyName !== keys[j]) {
                  olFeatures[i].set(newKeyName, properties[keys[j]]);
                  olFeatures[i].unset(keys[j]);
                }
              }
            }

            let kmlResult = tokml(collectionLayers.toGeoJSON());
            // '<?xml version="1.0" encoding="utf-8"?>' +
            // new KML().writeFeatures(olFeatures, {
            //   //20210108 - tedngok - hidden for only wgs84
            //   // ...options,
            // });

            convertedData =
              "text/xml;charset=utf-8," + encodeURIComponent(kmlResult);
            if (!isIE) {
              link.href = "data:" + convertedData;
              link.download =
                "download_" + this.downloadFileDateTimeString() + ".kml";
            } else {
              window.navigator.msSaveOrOpenBlob(
                new Blob([kmlResult], { type: "text/xml" }),
                "download_" + this.downloadFileDateTimeString() + ".kml"
              );
            }
            break;

          case GLOBAL.EXPORT.FORMATS.GML:
            this.$GA.export_gml();

            collectionLayers = this.core.drawnItems;

            olFeatures = new GeoJSON().readFeatures(
              collectionLayers.toGeoJSON()
            );

            let updateNewFieldNamesMapping = {};

            this.core.dynamicFields.map(
              (t) => (updateNewFieldNamesMapping[t.label] = t.label)
            );

            function generateNewKey(key, time = 0) {
              //trim space
              let tmpKey = key.trim();

              //replace special char
              tmpKey = tmpKey.replace(
                /[-&\/\\#,+()$~%.'":*?<>{}`!@# \n\r\t]/g,
                "_"
              );

              //utf8 symbol
              tmpKey = tmpKey.replace(/[\uFF08-\uFF60\u3008-\u301E]/g, "_");

              if (/^[0-9]$/.test(tmpKey)) {
                tmpKey = "_" + tmpKey;
              }

              if (time > 0) {
                tmpKey = tmpKey + "_" + time;
              }

              for (const k in updateNewFieldNamesMapping) {
                if (k == key) {
                  continue;
                }
                if (k == tmpKey || updateNewFieldNamesMapping[k] == tmpKey) {
                  return generateNewKey(key, ++time);
                  // break
                }
              }

              updateNewFieldNamesMapping[key] = tmpKey;

              // if (!updateNewFieldNamesMapping.hasOwnProperty(key)) {
              //   updateNewFieldNamesMapping[key] = tmpKey;
              // }

              return updateNewFieldNamesMapping[key];
            }

            for (let i = 0; i < this.core.dynamicFields.length; i++) {
              const dynamicField = this.core.dynamicFields[i];
              const { label } = dynamicField;

              generateNewKey(label);
            }

            // console.log(updateNewFieldNamesMapping);

            for (let i = 0; i < olFeatures.length; i++) {
              // let keys = olFeatures[i].getKeys();
              let properties = olFeatures[i].getProperties();

              // console.log(properties)

              //add back missing field case
              for (const k in updateNewFieldNamesMapping) {
                if (properties.hasOwnProperty(k)) {
                  continue;
                } else {
                  properties[k] = "";
                }
              }

              for (let property in properties) {
                if (property == "geometry") {
                  continue;
                }

                olFeatures[i].unset(property);

                olFeatures[i].set(
                  updateNewFieldNamesMapping[property],
                  properties[property]
                );

                // if (newKeyName !== "geometry") {
                //   if (additionalFieldName.indexOf(newKeyName) < 0) {
                //     additionalFieldName.push(newKeyName);
                //   }
                // }

                // console.log(additionalFieldName);

                // //if (newKeyName !== property) {

                // if (additionalFieldName.indexOf(newKeyName) >= 0) {
                //   olFeatures[i].unset(property);
                //   olFeatures[i].set(newKeyName, properties[property]);
                // }
              }
            }

            //[0].geometryChangeKey_.target.flatCoordinates
            /*
           [{"disposed":false,"pendingRemovals_":{},"dispatching_":{},"listeners_":{"change:geometry":[null]},"revision_":1,"ol_uid":"28","values_":{"geometry":{"disposed":false,"pendingRemovals_":null,"dispatching_":null,"listeners_":{"change":[null]},"revision_":1,"ol_uid":"27","values_":null,"extent_":[null,null,null,null],"extentRevision_":-1,"simplifiedGeometryMaxMinSquaredTolerance":0,"simplifiedGeometryRevision":0,"layout":"XYZ","stride":3,"flatCoordinates":[114.201878,22.381763,-2.79325]},"OBJECTID":"1","DATASET_EN":"Clinics / Health Centres under the Department of Health","DATASET_TC":"衛生署轄下的診所及健康中心","NAME_EN":"Pamela Youde Child Assessment Centre (Shatin)","ADDRESS_EN":"2/F, 31-33 Chap Wai Kon Street, Sha Tin, N.T.","NAME_TC":"尤德夫人兒童體能智力測驗中心(沙田)","ADDRESS_TC":"新界沙田插桅杆街31-33號2字樓","SEARCH01_EN":"CHILD ASSESSMENT CENTRES","SEARCH01_TC":"兒童體能智力測驗中心","SEARCH02_EN":"SHA TIN","SEARCH02_TC":"沙田"},"geometryName_":"geometry","style_":null,"geometryChangeKey_":{"target":{"disposed":false,"pendingRemovals_":null,"dispatching_":null,"listeners_":{"change":[null]},"revision_":1,"ol_uid":"27","values_":null,"extent_":[null,null,null,null],"extentRevision_":-1,"simplifiedGeometryMaxMinSquaredTolerance":0,"simplifiedGeometryRevision":0,"layout":"XYZ","stride":3,"flatCoordinates":[114.201878,22.381763,-2.79325]},"type":"change"}},{"disposed":false,"pendingRemovals_":{},"dispatching_":{},"listeners_":{"change:geometry":[null]},"revision_":1,"ol_uid":"30","values_":{"geometry":{"disposed":false,"pendingRemovals_":null,"dispatching_":null,"listeners_":{"change":[null]},"revision_":1,"ol_uid":"29","values_":null,"extent_":[null,null,null,null],"extentRevision_":-1,"simplifiedGeometryMaxMinSquaredTolerance":0,"simplifiedGeometryRevision":0,"layout":"XYZ","stride":3,"flatCoordinates":[114.216953,22.317052,-2.567899]},"OBJECTID":"2","DATASET_EN":"Clinics / Health Centres under the Department of Health","DATASET_TC":"衛生署轄下的診所及健康中心","NAME_EN":"Ngau Tau Kok Child Assessment Centre","ADDRESS_EN":"1/F, Ngau Tau Kok Jockey Club Clinic, 60 Ting On Street, Ngau Tau Kok, Kln.","NAME_TC":"牛頭角兒童體能智力測驗中心","ADDRESS_TC":"九龍牛頭角安定街60號牛頭角賽馬會診所1字樓","SEARCH01_EN":"CHILD ASSESSMENT CENTRES","SEARCH01_TC":"兒童體能智力測驗中心","SEARCH02_EN":"NGAU TAU KOK","SEARCH02_TC":"牛頭角"},"geometryName_":"geometry","style_":null,"geometryChangeKey_":{"target":{"disposed":false,"pendingRemovals_":null,"dispatching_":null,"listeners_":{"change":[null]},"revision_":1,"ol_uid":"29","values_":null,"extent_":[null,null,null,null],"extentRevision_":-1,"simplifiedGeometryMaxMinSquaredTolerance":0,"simplifiedGeometryRevision":0,"layout":"XYZ","stride":3,"flatCoordinates":[114.216953,22.317052,-2.567899]},"type":"change"}}]


            */
            let gmlEnvelope = this.getGmlEnvelope(olFeatures);

            gmlString = new GML({
              featureNS: "http://www.opengis.net/gml",
              featureType: this.core.layerName,
              srsName: "urn:x-ogc:def:crs:EPSG:4326",
            }).writeFeatures(olFeatures, {});
            let fileNameStamp = this.downloadFileDateTimeString();

            let gmlResult =
              '<?xml version="1.0" encoding="utf-8"?>' +
              // '<wfs:FeatureCollection xmlns:geotagging="https://geodata.gov.hk/xmlns/geodatastore/1.0.0"' +
              '<gml:FeatureCollection xmlns:gt="https://geodata.gov.hk/gt/"' +
              ' xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"' +
              ' xmlns:gml="http://www.opengis.net/gml"' +
              //' xmlns="http://www.opengis.net/gml"' +
              ' xmlns:xlink="http://www.w3.org/1999/xlink"' +
              ' xsi:schemaLocation="https://geodata.gov.hk/gt/ download_' +
              fileNameStamp +
              '.xsd">' +
              " <gml:boundedBy>" +
              ' <gml:Envelope srsName="urn:x-ogc:def:crs:EPSG:4326" srsDimension="2" >' +
              " <gml:lowerCorner>" +
              gmlEnvelope.lowerCornerX +
              " " +
              gmlEnvelope.lowerCornerY +
              "</gml:lowerCorner>" +
              " <gml:upperCorner>" +
              gmlEnvelope.upperCornerX +
              " " +
              gmlEnvelope.upperCornerY +
              "</gml:upperCorner>" +
              " </gml:Envelope>" +
              " </gml:boundedBy>" +
              gmlString +
              "</gml:FeatureCollection>";

            // convertedData = "text/xml;charset=utf-8," + encodeURIComponent( this.updateGmlFormat(gmlResult, additionalFieldName));

            //  let xsdStr = "text/xml;charset=utf-8," + encodeURIComponent(this.getXsdStr(additionalFieldName))

            var zipU = new require("node-zip")();
            zipU.file(
              "download_" + fileNameStamp + ".xsd",
              // xmlFormat(this.getXsdStr(additionalFieldName), {
              xmlFormat(this.getXsdStr(updateNewFieldNamesMapping), {
                indentation: "  ",
                collapseContent: true,
              })
            );
            zipU.file(
              "download_" + fileNameStamp + ".gml",
              // xmlFormat(this.updateGmlFormat(gmlResult, additionalFieldName), {
              xmlFormat(
                this.updateGmlFormat(gmlResult, updateNewFieldNamesMapping),
                {
                  indentation: "  ",
                  collapseContent: true,
                }
              )
            );
            let zipData = zipU.generate({
              base64: false,
              compression: "DEFLATE",
            });
            let dlBuffer = new Buffer(zipData, "binary");

            if (!isIE) {
              let blob = new Blob([dlBuffer]);
              let url = URL.createObjectURL(blob);
              link.href = url;
              link.download = "download_" + fileNameStamp + ".zip";
            } else {
              window.navigator.msSaveOrOpenBlob(
                new Blob([dlBuffer]),
                "download_" + fileNameStamp + ".zip"
              );
            }
            break;

          // case "Shapefile":
          //   var options = {
          //     folder: "lands",
          //     types: {
          //       point: "points",
          //       polygon: "polygons",
          //       polyline: "lines",
          //     },
          //   };
          //   // a GeoJSON bridge for features
          //   shpwrite.download(geoJSON, options);
          //   break;
        }

        if (!isIE) {
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        this.export_modal = false;
        this.$GA.export_submit_success();
      } catch (e) {
        console.log(e);
        this.$GA.export_submit_fail();
      }
    },
  },
};
</script>
<style scoped>
/* Square button
#export_container .v-btn {
  width: 130px;
  height: 130px;
}
.lang-en #export_container .v-btn span {
  white-space: normal !important;
  width: 100px !important;
} */
</style>
<style>
#csdi-checkbox .v-label {
  margin-bottom: 0rem;
}
</style>
